import { combineReducers } from 'redux';
import translationsReducer from './translationsReducer';

const rootReducer = combineReducers({
  translations: translationsReducer,
});

export default rootReducer;
